import ApiaField from '../ApiaField';
import ApiaForm from '../ApiaForm';
import { IApiaField } from '../types';

export interface ILinkField extends IApiaField {
  getLabel(): void;
}

export default class LinkField extends ApiaField implements ILinkField {
  constructor(field: HTMLAnchorElement, form: ApiaForm) {
    super(field, form, []);
  }

  getLabel(): void {
    if (this.fldType) {
      throw new Error(
        `Apia JSApi Error: The field ${this.fldType} does not use a label`,
      );
    }
  }
}
